import {
  VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW,
  VENDOR_INVOICES_INVOICE_ADD,
  VENDOR_INVOICES_INVOICE_REMOVE,
  VENDOR_INVOICES_SET,
} from 'components/admin/work-orders/details/vendor-invoices/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { workOrdersApi } from 'services/api/work-orders-api';
import { vendorInvoicesApi } from 'services/api/vendor-invoices-api';
import { tasksApi } from 'services/api/tasks-api';

function addVendorInvoice(invoice) {
  return {
    type: VENDOR_INVOICES_INVOICE_ADD,
    payload: invoice,
  };
}

export function createVendorInvoice(taskId, values) {
  return (dispatch) => {
    return tasksApi.createVendorInvoices(taskId, values).then((response) => {
      if (response.ok) {
        dispatch(addVendorInvoice(response.invoice));
        dispatch(setShowAddInvoiceModal(false));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function deleteVendorInvoice(vendorInvoiceId) {
  return (dispatch) => {
    return vendorInvoicesApi
      .deleteVendorInvoice(vendorInvoiceId)
      .then((response) => {
        if (response.ok) {
          dispatch(removeVendorInvoice(vendorInvoiceId));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function getVendorInvoices(workOrderId) {
  return (dispatch) => {
    return workOrdersApi.getVendorInvoices(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(setVendorInvoices(response.invoices));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

function removeVendorInvoice(invoiceId) {
  return {
    type: VENDOR_INVOICES_INVOICE_REMOVE,
    payload: invoiceId,
  };
}

function setVendorInvoices(invoices) {
  return {
    type: VENDOR_INVOICES_SET,
    payload: invoices,
  };
}

export function setShowAddInvoiceModal(value) {
  return {
    type: VENDOR_INVOICES_ADD_INVOICE_MODAL_SHOW,
    payload: value,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/vendor-invoices/store/actions.js